import { useEffect } from 'react';
import { useLatestRef } from './useLatestRef';

interface Options {
  elementRef: React.RefObject<HTMLElement | null | undefined>;
  listen?: boolean;
}

type FocusAwayHandler = (target: HTMLElement) => any;

export const useFocusOutside = ({ elementRef, listen = true }: Options, handler: FocusAwayHandler) => {
  const handlerRef = useLatestRef(handler);

  useEffect(() => {
    if (!listen) return;

    const handleFocus = (event: FocusEvent) => {
      const target = event.target as HTMLElement;
      if (elementRef.current && !elementRef.current.contains(event.target as HTMLElement)) {
        handlerRef.current(target);
      }
    };

    document.addEventListener('focusin', handleFocus);
    return () => document.removeEventListener('focusin', handleFocus);
  }, [elementRef, handlerRef, listen]);
};
